module.exports = __webpack_public_path__ + "static/media/solution_wirefram_slider.4cb84fcc.png";